//@flow
import {capitalize} from 'lodash'
import I18n from 'I18n'
import {NotificationManager} from 'modules/Common/components/Notification'
import {getApiNameFromFailureAction} from 'modules/Common/utils/index'
import type {Action} from 'modules/Common/types'

export default function apiCatchErrorMiddleware(store: any) {
  return (next: Dispatch<Action<*>>) => (action: Action<*>): any => {
    if (action.type && action.type.includes('FAILURE')) {
      if (action.payload.error.toString() === 'TypeError: Failed to fetch') {
        const apiName = getApiNameFromFailureAction(action.type)
        NotificationManager.error(I18n.formatString(I18n.common.apiCannotBeReached, capitalize(apiName)), '', 500000)
      }
    }
    return next(action)
  }
}
